import { Button } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { doctorHealthHistoryBanner } from "@/assets/images";
import { doctorHealthHistoryBannerV2 } from "@/assets/images";
import { v4 as uuid } from "uuid";
import { useIsABTest } from "@/hooks/useIsABTest";

const DoctorHealthHistoryBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { isABTest_6_Header } = useIsABTest();

  const onSubmit = () => {
    setQuestionAnswer(true);
  };

  return (
    <>
      {!isABTest_6_Header && (
        <p className="section-title mb-4">
          Next, let's go through your health history.
        </p>
      )}

      <img
        src={
          isABTest_6_Header
            ? doctorHealthHistoryBannerV2
            : doctorHealthHistoryBanner
        }
        className="mx-auto"
        alt="Health History"
      />

      <Button onClick={onSubmit} />
    </>
  );
};

export { DoctorHealthHistoryBanner };
